import React from 'react';
import { Field } from 'redux-form';
import { M } from '@dashboard-experience/mastodon';
import PropTypes from 'prop-types';
import { SensitiveTextInput } from '../fields/mastodon';
import { Checkbox } from '../fields';
import * as V from '../../lib/validations';
import * as N from '../../lib/normalizations';
import { getFieldKey } from '../../utils';
import { bestAvailableDisplayText } from './helpers';
import { VERIFICATION_FORM_NAME } from '../../constants';

function getValidations(field) {
  const vals = [];
  const { validations, canDeclareNoSsn } = field;

  if (!canDeclareNoSsn) {
    vals.push(V.required);
  }

  if (validations) {
    validations.forEach(validation => {
      vals.push(V[validation]);
    });
  }
  return vals.filter(Boolean);
}

function MatrixSsnContainer({ field, noSsn, setField, untouchField }) {
  if (!field) return null;

  const { canDeclareNoSsn, comment, displayCommentInCandidatePortal, name } =
    field;
  const fieldKey = getFieldKey(field);

  const onNoSsnUpdate = ({ target: { checked } }) => {
    const fieldKeys = [`${fieldKey}.ssn`, `${fieldKey}.ssnConfirmation`];
    if (checked) {
      fieldKeys.forEach(key => {
        setField(key);
        untouchField(VERIFICATION_FORM_NAME, key);
      });
    }
  };

  return (
    <M.Container>
      <M.Grid className='cp-form-group'>
        {displayCommentInCandidatePortal && (
          <M.GridRow className='form-content form-comment'>{comment}</M.GridRow>
        )}
        <M.Container.Row>
          <M.Container.Col className='form-group-col' sm={4} md={4} lg={8}>
            <Field
              className='matrix-label-style'
              type='input'
              testId='ssn'
              name={`${fieldKey}.ssn`}
              placeholder={bestAvailableDisplayText(field, 'placeholder')}
              component={SensitiveTextInput}
              normalize={N[name]}
              validate={getValidations(field)}
              onPaste={e => e.preventDefault()}
              disabled={noSsn}
              labelControl={bestAvailableDisplayText(field, 'displayTitle')}
            />
          </M.Container.Col>
          <M.Container.Col sm={4} md={4} lg={8}>
            <Field
              type='input'
              testId='ssnConfirmation'
              className='ssnConfirmation matrix-label-style'
              name={`${fieldKey}.ssnConfirmation`}
              placeholder={bestAvailableDisplayText(field, 'placeholder')}
              component={SensitiveTextInput}
              normalize={N[name]}
              validate={[...getValidations(field), V.confirmationMatch]}
              onPaste={e => e.preventDefault()}
              disabled={noSsn}
              labelControl={bestAvailableDisplayText(
                field,
                'confirmationTitle',
              )}
            />
          </M.Container.Col>
        </M.Container.Row>
        {canDeclareNoSsn && (
          <M.Container.Row>
            <Field
              type='checkbox'
              testId={fieldKey}
              name={`${fieldKey}.noSsn`}
              label='labels.noSsn'
              className='inline-checkbox top-inline bottom-inline noSsn'
              onChange={onNoSsnUpdate}
              component={Checkbox}
              i18n
            />
          </M.Container.Row>
        )}
      </M.Grid>
    </M.Container>
  );
}

MatrixSsnContainer.propTypes = {
  field: PropTypes.object,
  noSsn: PropTypes.bool,
  setField: PropTypes.func.isRequired,
  untouchField: PropTypes.func.isRequired,
};

MatrixSsnContainer.defaultProps = {
  field: null,
  noSsn: false,
};

export default MatrixSsnContainer;
